import React from 'react';
import { FaTimes, FaCheck } from 'react-icons/fa';
import logoDark from '../../../assets/images/logo_small_dark.png';

const ComparisonSection = () => {
    const traditionalDisadvantages = [
        "Same content and speed for everyone, leaving some learners behind",
        "Courses and lessons are often the same year after year, lacking adaptability to modern needs",
        "Teachers and trainers spend hours creating lessons or training materials from scratch",
        "Experience difficulty getting through the material in a timely fashion"
    ];

    const nexgenAdvantages = [
        "Learn 10x faster and more efficiently - get all A’s",
        "Use AI to automatically transcribe your lectures and turn them into detailed summaries and notes",
        "Automatically create flash cards and quizzes to study",
        "Use the built-in AI tutor that’s already an expert in your course materials"
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Traditional vs. <span className="text-primary">Nexgen Learning</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        See how Nexgen Learning transforms the educational experience with cutting-edge technology
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Traditional Learning Card */}
                    <div className="bg-gray-900 rounded-2xl p-8 shadow-xl">
                        <div className="text-center mb-8">
                            <h3 className="text-2xl font-bold text-white mb-2">Without Nexgen Learning</h3>
                            <p className="text-gray-400">Traditional Learning Challenges</p>
                        </div>
                        <ul className="space-y-4">
                            {traditionalDisadvantages.map((item, index) => (
                                <li key={index} className="flex items-start space-x-3 pb-4 border-b border-gray-700 last:border-b-0">
                                    <FaTimes className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
                                    <span className="text-gray-300">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Nexgen Learning Card */}
                    <div className="bg-primary rounded-2xl p-8 shadow-xl border-2 border-primary/20">
                        <div className="text-center mb-8">
                            <img 
                                src={logoDark} 
                                alt="Nexgen Learning" 
                                className="h-12 mx-auto mb-4"
                            />
                        </div>
                        <ul className="space-y-4 text-white">
                            {nexgenAdvantages.map((item, index) => (
                                <li key={index} className="flex items-start space-x-3 pb-4 border-b border-white/20 last:border-b-0">
                                    <FaCheck className="w-5 h-5 text-gray-200 mt-1 flex-shrink-0" />
                                    <span className="text-gray-200">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ComparisonSection; 